<script setup lang="ts">
import * as Sentry from "@sentry/capacitor";
import { startRefreshingTokens } from "@api-client/auth/auth";
import { MoreHorizontal } from 'lucide-vue-next';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import {
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuPortal
} from "@/components/ui/dropdown-menu";
import { useColorMode } from "@vueuse/core";
import { Monitor, Moon, Sun } from "lucide-vue-next";

const mode = useColorMode();

const restartApp = () => {
    window.location.reload();
}

const throwNativeCapacitorError = () => {
    Sentry.nativeCrash(); // kills the app as test error — native layer
}

const IS_DEV = import.meta.env.DEV;
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <Button variant="ghost"
                    size="icon">
                <MoreHorizontal />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
            <DropdownMenuItem v-if="IS_DEV"
                              @click="startRefreshingTokens()">
                DEV: Refresh Token
            </DropdownMenuItem>

            <DropdownMenuItem @click="restartApp">
                Restart
            </DropdownMenuItem>
            <DropdownMenuSeparator />

            <DropdownMenuItem @click="throwNativeCapacitorError">
                Test Native Error
            </DropdownMenuItem>
            <DropdownMenuSeparator />

            <DropdownMenuSub>
                <DropdownMenuSubTrigger>
                    <Moon v-if="mode === 'dark'"
                          class="mr-2 h-4 w-4" />
                    <Sun v-else-if="mode === 'light'"
                         class="mr-2 h-4 w-4" />
                    <span class="capitalize">{{ mode }}</span>
                </DropdownMenuSubTrigger>
                <DropdownMenuPortal>
                    <DropdownMenuSubContent>
                        <DropdownMenuItem @click="mode = 'light'">
                            <Sun />
                            Light
                        </DropdownMenuItem>
                        <DropdownMenuItem @click="mode = 'dark'">
                            <Moon />
                            Dark
                        </DropdownMenuItem>
                        <DropdownMenuItem @click="mode = 'auto'">
                            <Monitor />
                            System
                        </DropdownMenuItem>
                    </DropdownMenuSubContent>
                </DropdownMenuPortal>
            </DropdownMenuSub>

        </DropdownMenuContent>
    </DropdownMenu>
</template>